/*
 * Copyright (c) 2020  Apricad LLC. All Rights Reserved.
 */

import * as React from "react";
import createStyles from "@material-ui/core/styles/createStyles";
import withStyles, { WithStyles } from "@material-ui/core/styles/withStyles";
import classNames from "classnames";

import { sectionHowStyle } from "assets/jss/views/landingPage/landingPageSectionsStyle";
import { howContent } from "./landingPageContent";
import { sWhat } from "assets/jss/views/ResStrings";

// CT Kit
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import InfoArea from "components/InfoArea/InfoArea.jsx";

const styles = createStyles(sectionHowStyle as any);
interface Props extends WithStyles<typeof styles> {
  // other properties, if any
}

const PhoenixHowBase: React.FC<Props> = ({ classes }: Props) => {
  const renderHowCard = () =>
    howContent.map((content, idx) => (
      <GridItem
        xs={12}
        sm={6}
        md={3}
        className={classes.featuresShow}
        key={idx}>
        <InfoArea
          className={classes.infoArea}
          title={<span style={{ color: "white" }}>{content.title}</span>}
          description={<p>{content.content}</p>}
          icon={content.icon}
          vertical={true}
        />
      </GridItem>
    ));

  return (
    <div className={classes.section}>
      <div
        className={classes.features5}
        style={{
          backgroundImage: `url(${require("assets/img/course4.jpg")})`,
        }}>
        <GridItem md={8} className={classNames(classes.mlAuto, classes.mrAuto)}>
          <h2 className={classes.title}>{sWhat}</h2>
        </GridItem>
        <div className={classes.container}>
          <GridContainer justify="center">{renderHowCard()}</GridContainer>
        </div>
      </div>
    </div>
  );
};

export const PhoenixHow = withStyles(styles)(PhoenixHowBase);
